/// <amd-module name="Tfs/ReduxCommon/Modules/Teams/TeamReducer" />
import { default as produce } from "immer";
import { TeamActions, TeamActionTypes } from "Tfs/ReduxCommon/Modules/Teams/TeamActions";
import { ITeamState } from "Tfs/ReduxCommon/Modules/Teams/TeamContracts";

export function teamReducer(state: ITeamState, action: TeamActions): ITeamState {
    state = state || getDefaultState();

    return produce(state, draft => {
        switch (action.type) {
            case TeamActionTypes.BeginLoadTeams: {
                draft.loading = true;
                break;
            }

            case TeamActionTypes.LoadTeamsFailed: {
                draft.error = action.payload;
                draft.loading = false;
                break;
            }

            case TeamActionTypes.LoadTeamsSucceeded: {
                draft.teams = action.payload;
                draft.loading = false;
                break;
            }
        }
    });
}

function getDefaultState(): ITeamState {
    return {
        loading: false
    };
}
